import config from "../boot/config";
import http from "../boot/http.js";
import { DateTime } from "../utils";

const route = "Rule/";

export default class {
	static GetRulesForCategory(categoryCode, filter, from, to, siteName) {
		let url = `${config.baseUrl + route}GetRulesForCategory`;

		return http({ url, method: "GET", categoryCode, from, to, filter, siteName })
			.then(data => data)
			.catch(error => error);
	}

	static GetRuleInstanceSearch(query, filter, from, to, siteName) {
		let url = `${config.baseUrl + route}GetRuleInstanceSearch`;

		return http({ url, method: "GET", query, from, to, filter, siteName })
			.then(data => data)
			.catch(error => error);
	}

	static DeleteComment(reportCommentId) {
		let url = `${config.baseUrl + route}DeleteReportComment`;

		return http({ url, method: "POST", reportCommentId })
			.then(data => data)
			.catch(error => error);
	}

	static GetReportComments(ruleInstanceId, from, to) {
		let url = `${config.baseUrl + route}GetReportComments`;

		return http({ url, method: "GET", ruleInstanceId, from: from.toISOString(), to: to.toISOString() })
			.then(data => data)
			.catch(error => error);
	}

	static GetReportCommentsChart(ruleInstanceId, from, to) {
		let url = `${config.baseUrl + route}GetReportCommentsChart`;

		return http({ url, method: "GET", ruleInstanceId, from: from.toISOString(), to: to.toISOString() })
			.then(data => data)
			.catch(error => error);
	}

	static CreateReportComment(ruleInstanceId, description, y, from, to, isGeneric) {
		let url = `${config.baseUrl + route}CreateReportComment`;

		let parseJwt = function (token) {
			var base64Url = token.split('.')[1];
			var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
				 return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
	  
			return JSON.parse(base64);
	  };

		let token = localStorage.getItem(config.tokenKey);
		let jwt = parseJwt(token);

		let data = {
			ruleInstanceId: ruleInstanceId, 
			description: description, 
			y: y ? y : null, 
			username: jwt.username,
			fromDate: (from instanceof Date) ? from.toISOString() : (new Date(from)).toISOString(),
			toDate: to ? to.toISOString() : null, 
			isGeneric,
		};
		
		return http({ url, method: "POST", data: data})
			.then(data => data)
			.catch(error => error);
	}

	static GetRuleInstsForRule(categoryCode, filter, from, to, siteName) {
		let url = `${config.baseUrl + route}GetRuleInstsForRule`;

		return http({ url, method: "GET", categoryCode, from, to, filter, siteName })
			.then(data => data)
			.catch(error => error);
	}

	static GetOutcomesForRuleInst(ruleInstanceId, filter, from, to) {
		let url = `${config.baseUrl + route}GetRuleOutcomesForRuleInst`;

		return http({ url, method: "GET", ruleInstanceId, from, to, filter})
			.then(data => data)
			.catch(error => error);
	}

	static GetRuleInstance(ruleInstanceId) {
		let url = `${config.baseUrl + route}GetRuleInstance`;

		return http({ url, method: "GET", ruleInstanceId })
			.then(data => data)
			.catch(error => error);
	}

	static GetFailedRuleInstanceOutcomesBySiteName(siteName, toDate) {
		let url = `${config.baseUrl + route}GetFailedRuleInstanceOutcomesBySiteName`;

		let dateString = DateTime.toISOstring(toDate);

		return http({ url, method: "GET", siteName, toDate: dateString })
			.then(data => data)
			.catch(error => error);
	}

	static GetRuleCategoryDescriptions() {
		let url = `${config.baseUrl + route}GetRuleCategoryDescriptions`;

		return http({ url, method: "GET" })
			.then(data => data)
			.catch(error => error);
	}

	static GetRuleCategories(filter, from, to, siteName) {
		let url = `${config.baseUrl + route}GetRuleCategories`;

		return http({ url, method: "GET", from, to, filter, siteName })
			.then(data => data)
			.catch(error => error);
	}

	static GetDataForTimeChange(ruleCatas, filter, from, to, siteName, canceller) {
		let url = `${config.baseUrl + route}GetDataForTimeChange`;

		return http({ url, method: "POST", data: { ruleCatas }, from, to, filter, siteName }, false, canceller)
			.then(data => data)
			.catch(error => error);
	}

	static GetLookupsForLearnedRule(ruleInstanceId, from, to) {
		let url = `${config.baseUrl + route}GetLookupsForLearnedRule`;

		return http({ url, method: "GET", ruleInstanceId, from, to })
			.then(data => data)
			.catch(error => error);
	}

	static GetActionAudits(ruleInstanceId, from, to) {
		let url = `${config.baseUrl + route}GetActionAudits`;

		return http({ url, method: "GET", ruleInstanceId, from, to })
			.then(data => data)
			.catch(error => error);
	}

	static GetRuleRunTimes(ruleInstanceId, from, to) {
		let url = `${config.baseUrl + route}GetRuleRunTimes`;

		return http({ url, method: "GET", ruleInstanceId, from, to })
			.then(data => data)
			.catch(error => error);
	}

	static GetRuleOutcomes(ruleInstanceId, from, to) {
		let url = `${config.baseUrl + route}GetRuleOutcomes`;

		return http({ url, method: "GET", ruleInstanceId, from: from.toISOString(), to: to.toISOString() })
			.then(data => data)
			.catch(error => error);
	}

	static GetRulePointOutcomes(ruleInstanceId, from, to) {
		let url = `${config.baseUrl + route}GetRulePointOutcomes`;

		return http({ url, method: "GET", ruleInstanceId, from: from.toISOString(), to: to.toISOString() })
			.then(data => data)
			.catch(error => error);
	}

	static GetRuleErrors(ruleInstanceId, from, to) {
		let url = `${config.baseUrl + route}GetRuleErrors`;

		return http({ url, method: "GET", ruleInstanceId, from: from.toISOString(), to: to.toISOString() })
			.then(data => data)
			.catch(error => error);
	}

	static SetEnabled(ruleInstanceId, enabled) {
		let url = `${config.baseUrl + route}SetEnabled`;

		return http({ url, method: "POST", ruleInstanceId, enabled })
			.then(data => data)
			.catch(error => error);
	}

	static GetRuleSummaryStats(from, to) {
		let url = `${config.baseUrl + route}GetRuleSummaryStats`;

		return http({ url, method: "GET", from: from.toISOString(), to: to.toISOString() })
			.then(data => data)
			.catch(error => error);
	}

	static GetRuleStats(siteName, from, to, query, enabledFilter) {
		let url = `${config.baseUrl + route}GetRuleStats`;

		return http({ url, method: "GET", siteName, from: from.toISOString(), to: to.toISOString(), query, enabledFilter })
			.then(data => data)
			.catch(error => error);
	 }
	 
	static GetRuleFailStats(siteName, from, to) {
		let url = `${config.baseUrl + route}GetRuleFailStats`;

		return http({ url, method: "GET", siteName, from: from.toISOString(), to: to.toISOString()})
			.then(data => data)
			.catch(error => error);
	}
    
	static GetRuleInstanceScheduleAndConfigJson(ruleInstanceId) {
			const url = `${config.baseUrl + route}GetRuleInstanceScheduleAndConfigJson`;

			return http({ url, method: "GET", ruleInstanceId })
					.then(data => data)
					.catch(error => error);
	}




	static ruleStatusIntToText(integer) {

		const ruleStatusEnum = {
			0: "PRE_CON_FAIL",
			1: "TEST_START",
			2: "RULE_PASS",
			3: "RULE_FAIL",
			4: "RULE_PAUSE",
			5: "TEST_END",
			6: "RULE_ABORT"
		}

		return ruleStatusEnum[integer];

	}

	/* static GetRulesForSites(objectIds) {
      let url = `${config.baseUrl + route}GetRulesForSites`;

      return http({ url, method: "POST", data: objectIds })
         .then(data => data)
         .catch(error => error);
   }*/
}



// WEBPACK FOOTER //
// ./src/services/rules.js